import PropTypes from 'prop-types';

import { Smi2, Infox, Smi24 } from 'core/components/Partners';
import withBreakpoint from 'core/hocs/withBreakpoint';
import breakpointPropTypes from 'core/utils/prop-types/breakpoint';

const mapPartners = {
  '24smi': Smi24,
  'infox': Infox,
  'smi2': Smi2,
};


function ExchangeWithMarkup(props, context) {
  const {
    pageType,
    blockType,
    breakpoint,
    partner,
  } = props;

  const {
    siteName,
  } = context;

  const {
    type: partnerType,
    height: partnerHeight,
    id: partnerId,
  } = partner;

  const Partner = mapPartners[partnerType];

  return (
    <div
      {...{
        [`data-${siteName}-${breakpoint}`]: `exchange_block::${pageType}::${blockType}::${partnerType}::${partnerId}`,
      }}
    >
      <Partner id={partnerId} height={partnerHeight} />
    </div>
  );
}

ExchangeWithMarkup.propTypes = {
  pageType: PropTypes.string,
  blockType: PropTypes.string,
  breakpoint: breakpointPropTypes(),
  partner: PropTypes.shape({
    id: PropTypes.number,
    percent: PropTypes.number,
    type: PropTypes.string,
    height: PropTypes.number,
  }),
};

ExchangeWithMarkup.contextTypes = {
  siteName: PropTypes.string,
};

export default withBreakpoint(ExchangeWithMarkup);
